import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { verifyTokenStatus } from '@/modules/RealtimeAttendance/services'
import { useAttendanceCallStore } from '@/modules/RealtimeAttendance/store/useAttendanceCall'
import { FunctionComponent, useCallback, useLayoutEffect } from 'react'
import { validateRulesToAccessMeetStore } from './store'
import { useCheckCnxTissTokenRequirement } from '@/modules/RealtimeAttendance/queries/useCheckClinicTokenRequirement '

export const validateRulesToAccessMeet =
  // eslint-disable-next-line react/display-name
  (Component: FunctionComponent) => () => {
    const attendanceCall = useAttendanceCallStore(store => store.attendanceCall)
    const { data: requiresCnxTissTokenValidation } =
      useCheckCnxTissTokenRequirement()
    const [isAbleToAccessMeet, setIsAbleToAccessMeet] =
      validateRulesToAccessMeetStore(store => [
        store.isAbleToAccessMeet,
        store.setIsAbleToAccessMeet,
      ])
    const { clinic } = useAuthContext()
    const { showModal } = useModalContext()

    const handleTokenValidation = useCallback(async () => {
      setIsAbleToAccessMeet(false)
      const tokenIsValidated = await verifyTokenStatus(
        Number(attendanceCall.attendanceId),
      )

      if (tokenIsValidated) {
        setIsAbleToAccessMeet(true)
      } else {
        showModal('CALL_STARTED_WITH_TOKEN', {
          title: 'Informe o token de segurança',
          persistent: true,
        })
      }
    }, [attendanceCall.attendanceId, setIsAbleToAccessMeet, showModal])

    useLayoutEffect(() => {
      if (
        clinic?.flag?.LiberarChamadaPorTokenAutorizacaoExterno ||
        requiresCnxTissTokenValidation
      ) {
        handleTokenValidation()
      }
    }, [
      clinic?.flag?.LiberarChamadaPorTokenAutorizacaoExterno,
      handleTokenValidation,
      requiresCnxTissTokenValidation,
    ])

    return isAbleToAccessMeet ? <Component /> : null
  }
